var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconContentsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.268 9.9947L31.3672 14.7443C31.4194 14.7748 31.4685 14.8094 31.5141 14.8473C32.8806 15.7849 32.8313 17.8678 31.3661 18.7227C31.3655 18.723 31.3649 18.7234 31.3643 18.7237L23.2591 23.4768C21.7403 24.3501 19.8008 23.2758 19.8008 21.4831V11.9831C19.8008 10.2077 21.7307 9.09227 23.268 9.9947ZM22.0132 11.9301C22.0074 11.9397 22.0008 11.9545 22.0008 11.9831V21.4831C22.0008 21.5116 22.0072 21.525 22.0121 21.5329C22.0187 21.5439 22.0312 21.5577 22.0512 21.5691C22.0712 21.5805 22.0915 21.5854 22.1079 21.5856C22.1207 21.5858 22.1371 21.5837 22.1603 21.5708L30.2543 16.8243L30.2573 16.8225C30.2785 16.8102 30.2864 16.7992 30.2911 16.7905C30.2976 16.7788 30.3033 16.7607 30.3033 16.7381C30.3033 16.7155 30.2976 16.6974 30.2911 16.6857C30.2864 16.677 30.2785 16.6661 30.2573 16.6537C30.2162 16.6298 30.1771 16.6035 30.14 16.5749L22.1543 11.892C22.1309 11.8782 22.1154 11.8763 22.1054 11.8765C22.0919 11.8766 22.0734 11.8807 22.0537 11.8919C22.0341 11.9032 22.0207 11.9176 22.0132 11.9301Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2207 26.7035C27.2207 26.096 27.7132 25.6035 28.3207 25.6035H38.4907C39.0982 25.6035 39.5907 26.096 39.5907 26.7035V36.8735C39.5907 37.481 39.0982 37.9735 38.4907 37.9735H28.3207C27.7132 37.9735 27.2207 37.481 27.2207 36.8735V26.7035ZM29.4207 27.8035V35.7735H37.3907V27.8035H29.4207Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9502 27.4432C12.5532 27.4432 10.6102 29.3862 10.6102 31.7832C10.6102 34.1801 12.5532 36.1232 14.9502 36.1232C17.3471 36.1232 19.2902 34.1801 19.2902 31.7832C19.2902 29.3862 17.3471 27.4432 14.9502 27.4432ZM14.9502 38.3232C11.3382 38.3232 8.41016 35.3951 8.41016 31.7832C8.41016 28.1712 11.3382 25.2432 14.9502 25.2432C18.5621 25.2432 21.4902 28.1712 21.4902 31.7832C21.4902 35.3951 18.5621 38.3232 14.9502 38.3232Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContentsLight);
export default __webpack_public_path__ + "static/media/icon_contents_light.1d0da06f.svg";
export { ForwardRef as ReactComponent };